import moment from 'moment-timezone';

import formatDate from '@/helpers/format/format-date';
import formatTime from '@/helpers/format/format-time';
import http from '@/services/http';


const pickupTimes = {
  /** NOTE:
   * Order Rules set in the DB per merchant can affect the days and times that are returned.
   * Example: If a merchant order rule extends the pickup time by 30 mintues due to an order
   * amount total >= $60, then an updated list of days and times will be returned.
  */
  async getPickupDays(options) {
    try {
      const data = await pickupTimes.getDaysAndTimesRaw(options);

      const times = pickupTimes.parseTimes(data, options.location, options.merchant.options.hideAsapPickupTimeLabel);

      return times;
    }

    catch (error) {
      throw error;
    }
  },

  async getAsapTimestamp(options) {
    try {
      const data = await pickupTimes.getDaysAndTimesRaw(options);

      if (data.earliestPickupTime) {
        return data.earliestPickupTime;
      }

      throw new Error('No pickup times available for location.');
    }

    catch (error) {
      throw error;
    }
  },

  async getDaysAndTimesRaw(options) {
    try {
      const offset = options.order.preparationTime || '00:15:00';

      const daysAhead = options.daysAhead ?? options.location.maximumOrderAheadDays;

      const orderItems = options.order.orderItems.map(orderItem => ({
        categoryId: orderItem.categoryId,
        menuItemId: orderItem.menuItemId,
        quantity: orderItem.quantity
      }));

      const requestBody = {
        daysAhead,
        deliveryTimeOffset: options?.deliveryTimeOffset,
        fulfillmentType: options.order.fulfillmentType,
        orderItems
      };

      const response = await http.post(`/cardfree-api/v1/location/store/${options.location.storeId}/pickup-time/${offset}?menu-type=${options.menuType}`, requestBody);

      return response.data;
    }

    catch (error) {
      throw error;
    }
  },

  parseTimes(data, location, hideAsapPickupTimeLabel) {
    const days = {};
    const times = data.pickupTimes;

    if (data.earliestDeliveryTime) {
      times.unshift({
        isAvailable: true,
        pickupTime: data.earliestDeliveryTime
      });
    }

    else if (data.earliestPickupTime) {
      times.unshift({
        isAvailable: true,
        pickupTime: data.earliestPickupTime
      });
    }

    times.forEach((time) => {
      if (!time.isAvailable) {
        return;
      }

      const timestamp = time.deliveryTime || time.pickupTime;
      const m = moment(timestamp).tz(location.timeZone);
      const day = formatDate(m.toDate(), { style: 'weekdayMonthDay', timeZone: location.timeZone });
      const timeOfDay = formatTime(timestamp, { timeZone: location.timeZone });

      days[day] = days[day] || [];

      days[day].push({
        display: timeOfDay,
        value: timestamp
      });
    });

    const result = [];

    Object.keys(days).forEach((day) => {
      result.push({
        display: day,
        value: day,
        times: days[day]
      });
    });

    if (result[0] && !hideAsapPickupTimeLabel) {
      result[0].times[0].display += ' (ASAP)';
    }

    return result;
  }
};

export default pickupTimes;
